import { render, staticRenderFns } from "./sandBoxItem.vue?vue&type=template&id=5fffd6e8&scoped=true&"
import script from "./sandBoxItem.vue?vue&type=script&lang=js&"
export * from "./sandBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./sandBoxItem.vue?vue&type=style&index=0&id=5fffd6e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fffd6e8",
  null
  
)

export default component.exports